export { default } from './DynamicProductCarousel'
